<template>
    <div>
        <div style="color: #00ff96;font-size: 1rem">采购申请</div>
        <div class="title">采购单</div>
        <a-descriptions bordered size="small" :column="2">
          <a-descriptions-item label="采购单号" :span="2">
            {{ detail.purchaseOrder }}
          </a-descriptions-item>
          <a-descriptions-item label="采购员">
            {{ detail.purchaser }}
          </a-descriptions-item>
          <a-descriptions-item label="采购时间">
            {{ detail.purchaseTime }}
          </a-descriptions-item>
          <a-descriptions-item label="申请原因" :span="2">
            {{ detail.reason }}
          </a-descriptions-item>
          <a-descriptions-item label="备注" :span="2">
            {{ detail.remark }}
          </a-descriptions-item>
          <a-descriptions-item label="附件" :span="2">
            <a-space v-if="detail.attachmentList">
              <a
                v-for="item in detail.attachmentList"
                :key="item"
                :href="item.completePath"
                >{{ item.name }}</a
              >
            </a-space>
          </a-descriptions-item>
        </a-descriptions>

        <div class="title">审批信息</div>
        <a-descriptions bordered size="small" :column="2">
          <a-descriptions-item label="审批状态" :span="2">
            <DataDictFinder
              dictType="AssetReviewStatus"
              :dictValue="detail.status"
              iconType="text"
            />
          </a-descriptions-item>
          <a-descriptions-item label="审批人">
            {{ detail.reviewer }}
          </a-descriptions-item>
          <a-descriptions-item label="审批时间">
            {{ detail.reviewTime }}
          </a-descriptions-item>
        </a-descriptions>

        <div class="title">物料清单</div>
        <Goods
          :disabled="true"
          :list="Array.isArray(detail.materialList) ? detail.materialList : []"
        />

        <div class="center">
          <a-space>
              <ButtonField text="关闭" @click="cancel" secondary />
              <template v-if="detail.status === 'REVIEWING'">
                  <ButtonField text="审核通过" primary @click="pass"/>
                  <ButtonField text="审核驳回" danger @click="reject"/>
              </template>
              <ButtonField v-else-if="detail.status === 'APPROVED'" text="确认接收" primary @click="receive"/>
          </a-space>
        </div>
  </div>
</template>

<script>
import { review, accept, fetchDetail } from "../api/buy";
import Goods from "./components/goods.vue";

export default {
  components: {
    Goods,
  },

  data() {
    return {
      detail: {},
      loading: false,
    };
  },
  props:{
      id:{
          type:String,
          required:true
      }
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      fetchDetail({
        id : this.id,
      }).then((res) => {
        if (res) {
          this.detail = Object.freeze(res);
        }
      });
    },
    pass() {
      this.loading = true;
      review({
        id: this.detail.id,
        status: "APPROVED",
      })
        .then(() => {
          this.getDetail();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    reject() {
      this.loading = true;
      review({
        id: this.detail.id,
        status: "REJECTED",
      })
        .then(() => {
          this.getDetail();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    receive() {
      this.loading = false;
      accept({
        id: this.detail.id,
      })
        .then(() => {
          this.getDetail();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    cancel() {
        this.$emit('show-index');
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  font-weight: bold;
  margin: 1rem 0;
  color: #adadad;
  border-left: 1px solid #adadad;
  padding-left: 1rem;
}
.center {
  margin-top: 24px;
  margin-bottom: 24px;
}
::v-deep .ant-descriptions-bordered .ant-descriptions-item-label{
  background-color:rgb(14, 27, 52);
  color: #fff;
}
::v-deep .ant-descriptions-bordered .ant-descriptions-item-label,::v-deep  .ant-descriptions-bordered .ant-descriptions-item-content{
  border-right: 0.1px solid #67927f;
  color: #d9d9d9;
}

::v-deep .ant-descriptions-bordered .ant-descriptions-row{
  border: 0.1px solid #67927f;
  color: #d9d9d9;
}

::v-deep .ant-descriptions-bordered .ant-descriptions-view{
  border: 0.1px solid #67927f;
  color: #d9d9d9;
}
</style>

